import { Anskaffningsformer, Planeringsstatus, VirkeskopKontraktstatus } from "~app/common/models/constants";
import { VacsKontraktstatus, VirkeskopKontraktstyp } from "./kontrakt-models";

export const KONTRAKTSTYPER = [
    VirkeskopKontraktstyp.Rundvirke,
    VirkeskopKontraktstyp.Grot,
    VirkeskopKontraktstyp.Skogsvard
];

type VacsStatusSearchOption = {
    status: string;
    statusCode: VacsKontraktstatus;
};

export const VACS_KONTRAKTSTATUSAR: VacsStatusSearchOption[] = [
    { status: "Kontrakt",
        statusCode: VacsKontraktstatus.KontraktInlast },
    { status: "Betalning inlagd",
        statusCode: VacsKontraktstatus.Betaln },
    { status: "Avräknat",
        statusCode: VacsKontraktstatus.Avraknat },
    { status: "Avslutat",
        statusCode: VacsKontraktstatus.Avslutat }
];

export const ANSKAFFNINGSFORMERSOKNING = [
    Anskaffningsformer.Virkeskop,
    Anskaffningsformer.CentralaVirkeskop
];

export const KONTRAKTSTATUSAR = [
    VirkeskopKontraktstatus.Anbud,
    VirkeskopKontraktstatus.Kontrakt,
    VirkeskopKontraktstatus.EjKopt,
    VirkeskopKontraktstatus.Vilande,
    VirkeskopKontraktstatus.Makulerat
];

export const KONTRAKTSTATUSARFPV = [
    VirkeskopKontraktstatus.Anbud,
    VirkeskopKontraktstatus.Kontrakt,
    VirkeskopKontraktstatus.Makulerat
];

export const ATGARD_PLANERINGSSTATUS = [
    Planeringsstatus.UnderPlanering,
    Planeringsstatus.Fardigplanerat,
    Planeringsstatus.Tillgangligt
];
